export function filterFieldsBySearchValue(fields: Array<string | undefined>, search?: string): boolean {
    if (!search) return true

    return !!fields.filter((field) => {
        if (!field) return false
        return field.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
    }).length
}
